
// // components/ProtectedAdminRoute.js
// import React from "react";
// import { Navigate } from "react-router-dom";

// const ProtectedRoute  = ({ children }) => {
//   const role = sessionStorage.getItem("role");

//   if (role !== "employee") {
//     return <Navigate to="/employee" replace />;
//   }

//   return children;
// };

// export default ProtectedRoute ;



// components/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ allowedRoles = [], children }) => {
  const role = sessionStorage.getItem("role");
  console.log(role,"roleeeee")

  if (!allowedRoles.includes(role)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export default ProtectedRoute;
